
export interface InventoryItem {
  product_naam: string;
  product_id: string;
  bc: string;
  locatie: string;
  magazijn: number;
  voorraad: number;
  eenheid: string;
  moq?: number; // Toegevoegde Minimum Order Quantity
  vrije_waarde_2?: number | null; // Fysiek gewicht
  timestamp?: string;
  similarity?: number; // Search relevance score
  timestamp_sync?: string; // Database sync timestamp
  id?: string; // Unique identifier
}

export const getMagazijnLabel = (number: number): string => {
  const magazijnen: Record<number, string> = {
    2: 'Goes',
    5: 'Dordrecht',
    7: 'PC',
    12: 'Breda'
  };
  
  return `${number} - ${magazijnen[number] || 'Onbekend'}`;
};
